module.exports = __webpack_public_path__ + "img/goodgreen.7b27cf57.png";